<template>
  <SubNavCardVue :buttons="buttons" />
</template>

<script>
import SubNavCardVue from "../../components/cards/SubNavCard.vue";

export default {
  components: { SubNavCardVue },
  data() {
    return {
      buttons: [
        {
          label: "Règlements clients",
          icon: "bi bi-people-fill",
          route: "payments-customers-index",
        },
        {
          label: "Règlements fournisseurs",
          icon: "bi bi-truck",
          route: "payments-suppliers-index",
        },
        {
          label: "Paiements réparations",
          icon: "bi bi-wrench-adjustable",
          route: "payments-repairs-index",
        },
      ],
    };
  },
};
</script>
